import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { Select2Module } from 'ng2-select2';
import { CurrencyInputDirective } from 'src/app/currency-input.directive';


// Components
import { NoDataMsgComponent } from './commons/no-data-msg/no-data-msg.component';
import { UserComponent } from './commons/user/user.component';
import { AccidentUserComponent } from '../app/accident/accident-user/accident-user.component';
import { AllFormListComponent } from './accident/all-form-list/all-form-list.component';
import { EnvironmentalIncidentReportingFormComponent } from './accident/environmental-incident-reporting-form/environmental-incident-reporting-form.component';
import { IncidentReportingFormComponent } from './accident/incident-reporting-form/incident-reporting-form.component';
import { IncidentInvestigationReportComponent } from './accident/incident-investigation-report/incident-investigation-report.component';
import { WitnessFormComponent } from './accident/witness-form/witness-form.component';
import { FileTileComponent } from './commons/file-tile/file-tile.component';
import { MaterialElevationDirective } from './commons/material-tile/material-elevation.directive';
import { SingleAccidentComponent } from './accident/single-accident/single-accident.component';
import { MatTabComponent } from './commons/mat-tab/mat-tab.component';
import { AssetListComponent } from './asset/asset-list/asset-list.component';
import { AllFormsComponent } from './asset/all-forms/all-forms.component';
import { FirstAidChecklistComponent } from './asset/first-aid-checklist/first-aid-checklist.component';
import { HandHeldPlantInspectionChecklistComponent } from './asset/hand-held-plant-inspection-checklist/hand-held-plant-inspection-checklist.component';
import { HandToolsInspectionChecklistComponent } from './asset/hand-tools-inspection-checklist/hand-tools-inspection-checklist.component';
import { VehicleInspectionChecklistComponent } from './asset/vehicle-inspection-checklist/vehicle-inspection-checklist.component'
import { InspectionFromComponent } from './asset/inspection-from/inspection-from.component'
import { MedicalChecklistComponent } from './asset/Inspection-forms/medical-checklist/medical-checklist.component'
import { SafteyCriticalFormComponent } from './asset/saftey-critical-form/saftey-critical-form.component';
import { AddCompModalComponent } from './competency/add-comp-modal/add-comp-modal.component';
import { NewFileModalComponent } from './files/new-file-modal/new-file-modal.component';
import { AddEvidenceModalComponent } from './portfolio/evidences/add-evidence-modal/add-evidence-modal.component'
import { JobHoursModelComponent } from './time-sheet/learner-single-week/job-hours-model/job-hours-model.component'
import { ColorBadgeComponent } from './commons/color-badge/color-badge.component';
// import { UserSingleWeekComponent } from './time-sheet/user-single-week/user-single-week.component';
//Modules/Libraries
import { CommonModule } from '@angular/common';
// import { MatCheckboxModule, MatDatepickerModule, MatDialogModule, MatDialogRef, MatInputModule, MatNativeDateModule, MatSlideToggleModule, MatSortModule, MAT_DIALOG_DATA } from '@angular/material';
// import { MatTabsModule } from '@angular/material/tabs'
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DatePickerComponent } from './commons/date-picker/date-picker.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
// import { MatButtonModule } from '@angular/material/button';
// import { MatStepperModule } from '@angular/material/stepper';
// import { MatSelectModule } from '@angular/material/select';
// import { MatIconModule } from '@angular/material/icon';
// import { MatPaginatorModule } from '@angular/material/paginator'
// import { MatTableModule } from '@angular/material/table';
// import { MatMenuModule } from '@angular/material/menu';
import { MatFormFieldModule } from '@angular/material/form-field';
// import { MatCardModule } from '@angular/material/card';
// import { MatSlideToggleModule } from '@angular/material/slide-toggle';

// import {MatSortModule} from '@angular/material/sort';
import { LoaderComponent } from '../app/commons/loader/loader.component'
import { importExpr } from '@angular/compiler/src/output/output_ast';
import { AgmCoreModule } from '@agm/core';
import { GoodPractiseReportComponent } from './accident/good-practise-report/good-practise-report.component';
import { CloseCallReportComponent } from './accident/close-call-report/close-call-report.component';
import { MapComponent } from './commons/map/map.component'
import { CompetencyDetailModalComponent } from './competency/competency-detail-modal/competency-detail-modal.component';
import { CompetencyListComponent } from './competency/competency-list/competency-list.component';
import { SiteDashboardComponent } from './sites(locations)/site-dashboard/site-dashboard.component';
import { AddSiteComponent } from './sites(locations)/add-site/add-site.component';
import { SiteAssetsComponent } from './sites(locations)/site-assets/site-assets.component';
import { ColorPickerModule } from 'ngx-color-picker';
import { ContextMenuModule } from 'ngx-contextmenu';
import { TableComponent } from './commons/table/table.component';
import { CdkColumnDef } from '@angular/cdk/table';
import { CdkTableModule } from '@angular/cdk/table';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { BreadCrumbComponent } from './commons/bread-crumb/bread-crumb.component';
import { FileDetailsComponent } from './commons/file-details/file-details.component';
import { ProfileComponent } from './commons/profile/profile.component';
import { MaterialTileComponent } from './commons/material-tile/material-tile.component';
import { MaterialsModule } from './materials.module';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { LocationTabComponent } from './commons/location-tab/location-tab.component';
import { NgxDocViewerModule } from 'ngx-doc-viewer';
import { FilesComponent } from './files/files.component';
import { UtilityService } from './services/utility.service';
import { environment } from '../environments/environment';
import { QrCodeModule } from 'ng-qrcode';
import { PieChartComponent } from './analytics_dashboard/pie-chart/pie-chart.component';
import { AnalyticDashboardComponent } from './analytics_dashboard/analytic-dashboard/analytic-dashboard.component';
import { CommentsComponent } from './commons/comments/comments.component';
import { TimeAgoPipe } from 'time-ago-pipe';
import { IronmanInspectionFormComponent } from './asset/Inspection-forms/ironman-inspection-form/ironman-inspection-form.component';
import { TimesheetApprovalComponent } from './labour-job/timesheet-approval/timesheet-approval.component';
import { SponsorPackComponent } from './induction/sponsor-pack/sponsor-pack.component';
import { SponsorPackPolicyComponent } from './induction/sponsor-pack-policy/sponsor-pack-policy.component';
import { LiveFatigueScoreComponent } from './analytics_dashboard/live-fatigue-score/live-fatigue-score.component';
import { SponsorPackV2Component } from './induction/sponsor-pack-v2/sponsor-pack-v2.component';
import { RailPpeListComponent } from './induction/rail-ppe-kit/rail-ppe-list/rail-ppe-list.component';
import { RailPpeKitCreateEditComponent } from './induction/rail-ppe-kit/rail-ppe-kit-create-edit/rail-ppe-kit-create-edit.component';


@NgModule({
        declarations: [
                AccidentUserComponent,
                NoDataMsgComponent,
                UserComponent,
                MapComponent,
                DatePickerComponent,
                AllFormListComponent,
                EnvironmentalIncidentReportingFormComponent,
                IncidentReportingFormComponent,
                IncidentInvestigationReportComponent,
                WitnessFormComponent,
                FileTileComponent,
                MaterialElevationDirective,
                SingleAccidentComponent,
                MatTabComponent,
                AssetListComponent,
                AllFormsComponent,
                FirstAidChecklistComponent,
                HandHeldPlantInspectionChecklistComponent,
                HandToolsInspectionChecklistComponent,
                VehicleInspectionChecklistComponent,
                InspectionFromComponent,
                GoodPractiseReportComponent,
                CloseCallReportComponent,
                MedicalChecklistComponent,
                SafteyCriticalFormComponent,
                LoaderComponent,
                AddCompModalComponent,
                NewFileModalComponent,
                AddEvidenceModalComponent,
                JobHoursModelComponent,
                CompetencyDetailModalComponent,
                CompetencyListComponent,
                SiteDashboardComponent,
                AddSiteComponent,
                SiteAssetsComponent,
                ColorBadgeComponent,
                TableComponent,
                BreadCrumbComponent,
                FileDetailsComponent,
                ProfileComponent,
                MaterialTileComponent,
                LocationTabComponent,
                FilesComponent,
                AnalyticDashboardComponent,
                PieChartComponent,
                CommentsComponent,
                TimeAgoPipe,
                IronmanInspectionFormComponent,
                TimesheetApprovalComponent,
                CurrencyInputDirective,
                SponsorPackComponent,
                SponsorPackPolicyComponent,
                LiveFatigueScoreComponent,
                SponsorPackV2Component,
                RailPpeListComponent,
                RailPpeKitCreateEditComponent
        ],
        imports: [
                CommonModule,
                RouterModule,
                NgbModule,
                MaterialsModule,
                FormsModule,
                MatFormFieldModule,
                ReactiveFormsModule,
                NgxMaterialTimepickerModule,
                ColorPickerModule,
                AgmCoreModule.forRoot({
                        apiKey: environment.AGM_API_KEY,
                        libraries: ['places']
                }),
                NgSelectModule,
                Select2Module,
                CdkTableModule,
                DragDropModule,
                NgCircleProgressModule.forRoot({}),
                NgxDaterangepickerMd.forRoot(),
                CalendarModule.forRoot({
                        provide: DateAdapter,
                        useFactory: adapterFactory
                }),
                CKEditorModule,
                NgxDocViewerModule,
                QrCodeModule
        ],
        exports: [
                CommonModule,
                NgbModule,
                NoDataMsgComponent,
                UserComponent,
                DatePickerComponent,
                MapComponent,
                AccidentUserComponent,
                AllFormListComponent,
                SingleAccidentComponent,
                FileTileComponent,
                MatTabComponent,
                AssetListComponent,
                LoaderComponent,
                CompetencyListComponent,
                SiteDashboardComponent,
                BreadCrumbComponent,
                FileDetailsComponent,
                ProfileComponent,
                ColorBadgeComponent,
                ColorPickerModule,
                ContextMenuModule,
                NgSelectModule,
                Select2Module,
                TableComponent,
                CdkTableModule,
                DragDropModule,
                NgCircleProgressModule,
                NgxDaterangepickerMd,
                CalendarModule,
                MaterialTileComponent,
                CKEditorModule,
                NgxDocViewerModule,
                FilesComponent,
                QrCodeModule,
                AnalyticDashboardComponent,
                PieChartComponent,
                CommentsComponent,
                TimeAgoPipe,
                ReactiveFormsModule,
                FormsModule,
                TimesheetApprovalComponent,
                CurrencyInputDirective,
                SponsorPackComponent,
                SponsorPackPolicyComponent,
                LiveFatigueScoreComponent,
                SponsorPackV2Component,
                RailPpeListComponent,
                RailPpeKitCreateEditComponent
        ],
        entryComponents: [
                CompetencyDetailModalComponent,
                AllFormsComponent,
                FirstAidChecklistComponent,
                HandHeldPlantInspectionChecklistComponent,
                HandToolsInspectionChecklistComponent,
                VehicleInspectionChecklistComponent,
                InspectionFromComponent,
                MedicalChecklistComponent,
                IncidentReportingFormComponent,
                SafteyCriticalFormComponent,
                AddCompModalComponent,
                AddEvidenceModalComponent,
                JobHoursModelComponent,
                AddSiteComponent,
                SiteAssetsComponent,
                CommentsComponent,
                IronmanInspectionFormComponent
        ],
        schemas: [CUSTOM_ELEMENTS_SCHEMA],
        providers: [CdkColumnDef, UtilityService]

})

export class SharedModule { }

